import { getViewportElement } from '.';

function onViewportScroll(fn: EventListener): Function {
  const viewport = getViewportElement(true);
  const scrollEventTarget = !viewport.parentElement ? window : viewport;

  scrollEventTarget.addEventListener('scroll', fn);

  return () => scrollEventTarget.removeEventListener('scroll', fn);
}

export default onViewportScroll;
